import Swal from "sweetalert2";

export const showSuccessAlert = (message = "Operation successful", callback = () => {}) => {
    Swal.fire({
        title: 'Success!',
        text: message,
        icon: 'success',
        confirmButtonText: 'OK'
    }).then(() => {
        callback();
    });
};

export const showErrorAlert = (message = "Something went wrong") => {
    Swal.fire({
        title: 'Error!',
        text: message,
        icon: 'error',
        confirmButtonText: 'OK'
    });
};

export const showConfirmAlert = (
    title = "Are you sure?",
    message = "This action cannot be undone!",
    confirmCallback = () => {},
    cancelCallback = () => {}
) => {
    Swal.fire({
        title: title,
        text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33'
    }).then((result) => {
        if (result.isConfirmed) {
            confirmCallback();
        } else {
            cancelCallback();
        }
    });
};

export const showLoadingAlert = (message = "Please wait...") => {
    Swal.fire({
        title: message,
        allowOutsideClick: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
};

export const closeAlert = () => {
    Swal.close();
};